import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturKlagenfurt() {
  return <LocationPage locationKey="klagenfurt" />;
}
